module.exports = __webpack_public_path__ + "static/media/icon-link-view-profile-settings.14ffa21c.svg";